import { render, staticRenderFns } from "./ProjectDestinySelectorMenu.vue?vue&type=template&id=1af87ff2&"
import script from "./ProjectDestinySelectorMenu.vue?vue&type=script&lang=js&"
export * from "./ProjectDestinySelectorMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports